import gql from 'graphql-tag'

export const ARCHIVE_MEDIA = gql`
  mutation archiveMedia($id: Int!) {
    archiveMedia(id: $id) {
      id
    }
  }
`
